// extracted by mini-css-extract-plugin
module.exports = {"container":"relative-overlay__container___MBS62","container-opaque":"relative-overlay__container-opaque___2kxEb relative-overlay__container___MBS62"};